var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _abortController, _cachedContent, _cartUpdateAbortController, _QuickAddComponent_instances, getSelectedVariantId_fn, _handleProductSelectUpdate, _handleCartUpdate, updateVariantPicker_fn, resetScroll_fn, stayVisibleUntilDialogCloses_fn, _openQuickAddModal, _closeQuickAddModal, syncVariantSelection_fn, _abortController2, _handleProductSelect, _handleDialogClose;
import { Component } from "@theme/component";
import { morph } from "@theme/morph";
import { ThemeEvents } from "@theme/events";
import { DialogComponent, DialogCloseEvent } from "@theme/dialog";
import { mediaQueryLarge, isMobileBreakpoint, getIOSVersion, fetchWithDeadline } from "@theme/utilities";
import VariantPicker from "@theme/variant-picker";
import { StandardEvents, ProductSelectEvent, CartLinesUpdateEvent } from "@shopify/events";
let quickAddGeneration = 0;
let quickAddOwner = null;
class QuickAddComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _QuickAddComponent_instances);
    __privateAdd(this, _abortController, null);
    __privateAdd(this, _cachedContent, /* @__PURE__ */ new Map());
    __privateAdd(this, _cartUpdateAbortController, new AbortController());
    __privateAdd(this, _handleProductSelectUpdate, (event) => {
      var _a;
      if (!(event.target instanceof HTMLElement)) return;
      if (event.target.closest("product-card") !== this.closest("product-card")) return;
      if (quickAddOwner === this) ++quickAddGeneration;
      __privateGet(this, _cachedContent).clear();
      (_a = __privateGet(this, _abortController)) == null ? void 0 : _a.abort();
      const productOptionsCount = this.dataset.productOptionsCount;
      const quickAddButton = productOptionsCount === "1" ? "add" : "choose";
      this.setAttribute("data-quick-add-button", quickAddButton);
    });
    __privateAdd(this, _handleCartUpdate, () => {
      __privateGet(this, _cachedContent).clear();
    });
    __publicField(this, "handleClick", async (event) => {
      var _a, _b;
      event.preventDefault();
      const currentUrl = this.productPageUrl;
      if (!currentUrl) return;
      const generation = ++quickAddGeneration;
      if (quickAddOwner && quickAddOwner !== this) (_a = __privateGet(quickAddOwner, _abortController)) == null ? void 0 : _a.abort();
      quickAddOwner = this;
      const current = () => generation === quickAddGeneration && !this.quickAddDetached && currentUrl === this.productPageUrl;
      try {
        let productGrid = __privateGet(this, _cachedContent).get(currentUrl);
        if (!productGrid) {
          const html = await this.fetchProductPage(currentUrl);
          if (!current()) return;
          productGrid = (_b = html == null ? void 0 : html.querySelector("[data-product-grid-content]")) == null ? void 0 : _b.cloneNode(true);
          if (!productGrid) {
            window.location.href = currentUrl;
            return;
          }
          __privateGet(this, _cachedContent).set(currentUrl, productGrid);
        }
        if (!current()) return;
        await this.updateQuickAddModal(productGrid.cloneNode(true));
        if (!current()) return;
        __privateMethod(this, _QuickAddComponent_instances, updateVariantPicker_fn).call(this, productGrid);
        __privateGet(this, _openQuickAddModal).call(this);
      } catch (error) {
        if (current()) window.location.href = currentUrl;
      }
    });
    __privateAdd(this, _openQuickAddModal, () => {
      var _a;
      const dialogComponent = document.getElementById("quick-add-dialog");
      if (!(dialogComponent instanceof QuickAddDialog)) return;
      __privateMethod(this, _QuickAddComponent_instances, stayVisibleUntilDialogCloses_fn).call(this, dialogComponent);
      dialogComponent.showDialog();
      const dialog = (_a = dialogComponent.refs) == null ? void 0 : _a.dialog;
      if (!dialog) return;
      dialog.addEventListener("animationstart", __privateMethod(this, _QuickAddComponent_instances, resetScroll_fn).bind(this), { once: true });
    });
    __privateAdd(this, _closeQuickAddModal, () => {
      var _a;
      if (quickAddOwner === this) {
        ++quickAddGeneration;
        (_a = __privateGet(this, _abortController)) == null ? void 0 : _a.abort();
      }
      const dialogComponent = document.getElementById("quick-add-dialog");
      if (!(dialogComponent instanceof QuickAddDialog)) return;
      dialogComponent.closeDialog();
    });
  }
  get productPageUrl() {
    const productCard = (
      /** @type {import('./product-card').ProductCard | null} */
      this.closest("product-card")
    );
    const hotspotProduct = (
      /** @type {import('./product-hotspot').ProductHotspotComponent | null} */
      this.closest("product-hotspot-component")
    );
    const productLink = (productCard == null ? void 0 : productCard.getProductCardLink()) || (hotspotProduct == null ? void 0 : hotspotProduct.getHotspotProductLink());
    if (!(productLink == null ? void 0 : productLink.href)) return "";
    const url = new URL(productLink.href);
    if (url.searchParams.has("variant")) {
      return url.toString();
    }
    const selectedVariantId = __privateMethod(this, _QuickAddComponent_instances, getSelectedVariantId_fn).call(this);
    if (selectedVariantId) {
      url.searchParams.set("variant", selectedVariantId);
    }
    return url.toString();
  }
  connectedCallback() {
    super.connectedCallback();
    this.quickAddDetached = false;
    if (__privateGet(this, _cartUpdateAbortController).signal.aborted) __privateSet(this, _cartUpdateAbortController, new AbortController());
    mediaQueryLarge.addEventListener("change", __privateGet(this, _closeQuickAddModal));
    document.addEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _handleCartUpdate), {
      signal: __privateGet(this, _cartUpdateAbortController).signal
    });
    document.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelectUpdate));
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    this.quickAddDetached = true;
    if (quickAddOwner === this) ++quickAddGeneration;
    mediaQueryLarge.removeEventListener("change", __privateGet(this, _closeQuickAddModal));
    (_a = __privateGet(this, _abortController)) == null ? void 0 : _a.abort();
    __privateGet(this, _cartUpdateAbortController).abort();
    document.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelectUpdate));
  }
  /**
   * Fetches the product page content
   * @param {string} productPageUrl - The URL of the product page to fetch
   * @returns {Promise<Document | null>}
   */
  async fetchProductPage(productPageUrl) {
    var _a, _b;
    if (!productPageUrl || this.quickAddDetached) return null;
    if (((_a = this.productPageRequest) == null ? void 0 : _a.url) === productPageUrl && !this.productPageRequest.controller.signal.aborted) return this.productPageRequest.promise;
    (_b = __privateGet(this, _abortController)) == null ? void 0 : _b.abort();
    const controller = new AbortController();
    __privateSet(this, _abortController, controller);
    const request = { url: productPageUrl, controller };
    request.promise = fetchWithDeadline(productPageUrl, { headers: { Accept: "text/html" }, cache: "no-store" }, controller, 15e3, async (response) => {
      if (!response.ok) throw new Error("Product request failed: " + response.status);
      return response.text();
    }).then((text) => {
      if (controller.signal.aborted || this.quickAddDetached || this.productPageRequest !== request) return null;
      return new DOMParser().parseFromString(text, "text/html");
    }).catch(() => null).finally(() => {
      if (this.productPageRequest === request) this.productPageRequest = null;
      if (__privateGet(this, _abortController) === controller) __privateSet(this, _abortController, null);
    });
    this.productPageRequest = request;
    return request.promise;
  }
  /**
   * Re-renders the variant picker.
   * @param {Element} productGrid - The product grid element
   */
  async updateQuickAddModal(productGrid) {
    const modalContent = document.getElementById("quick-add-modal-content");
    if (!productGrid || !modalContent) throw new Error("Quick add content missing");
    if (isMobileBreakpoint()) {
      const productDetails = productGrid.querySelector(".product-details");
      const productFormComponent = productGrid.querySelector("product-form-component");
      const variantPicker = productGrid.querySelector("variant-picker");
      const productPrice = productGrid.querySelector("product-price");
      const productTitle = document.createElement("a");
      productTitle.textContent = this.dataset.productTitle || "";
      productTitle.href = this.productPageUrl;
      const productHeader = document.createElement("div");
      productHeader.classList.add("product-header");
      productHeader.appendChild(productTitle);
      if (productPrice) {
        productHeader.appendChild(productPrice);
      }
      productGrid.appendChild(productHeader);
      if (variantPicker) {
        productGrid.appendChild(variantPicker);
      }
      if (productFormComponent) {
        productGrid.appendChild(productFormComponent);
      }
      productDetails == null ? void 0 : productDetails.remove();
    }
    const payload = productGrid.getAttribute("view-event-payload") || "";
    modalContent.setAttribute("view-event-payload", payload);
    morph(modalContent, productGrid);
    __privateMethod(this, _QuickAddComponent_instances, syncVariantSelection_fn).call(this, modalContent);
  }
}
_abortController = /* @__PURE__ */ new WeakMap();
_cachedContent = /* @__PURE__ */ new WeakMap();
_cartUpdateAbortController = /* @__PURE__ */ new WeakMap();
_QuickAddComponent_instances = /* @__PURE__ */ new WeakSet();
getSelectedVariantId_fn = function() {
  const productCard = (
    /** @type {import('./product-card').ProductCard | null} */
    this.closest("product-card")
  );
  return (productCard == null ? void 0 : productCard.getSelectedVariantId()) || null;
};
_handleProductSelectUpdate = /* @__PURE__ */ new WeakMap();
_handleCartUpdate = /* @__PURE__ */ new WeakMap();
updateVariantPicker_fn = function(newHtml) {
  const modalContent = document.getElementById("quick-add-modal-content");
  if (!modalContent) return;
  const variantPicker = (
    /** @type {VariantPicker | null} */
    modalContent.querySelector("variant-picker")
  );
  if (!variantPicker) return;
  variantPicker.updateVariantPicker(newHtml);
};
resetScroll_fn = function() {
  const dialogComponent = document.getElementById("quick-add-dialog");
  if (!(dialogComponent instanceof QuickAddDialog)) return;
  const productDetails = dialogComponent.querySelector(".product-details");
  const productMedia = dialogComponent.querySelector(".product-information__media");
  productDetails == null ? void 0 : productDetails.scrollTo({ top: 0, behavior: "instant" });
  productMedia == null ? void 0 : productMedia.scrollTo({ top: 0, behavior: "instant" });
};
stayVisibleUntilDialogCloses_fn = function(dialogComponent) {
  this.toggleAttribute("stay-visible", true);
  dialogComponent.addEventListener(DialogCloseEvent.eventName, () => this.toggleAttribute("stay-visible", false), {
    once: true
  });
};
_openQuickAddModal = /* @__PURE__ */ new WeakMap();
_closeQuickAddModal = /* @__PURE__ */ new WeakMap();
syncVariantSelection_fn = function(modalContent) {
  const selectedVariantId = __privateMethod(this, _QuickAddComponent_instances, getSelectedVariantId_fn).call(this);
  if (!selectedVariantId) return;
  const modalInputs = modalContent.querySelectorAll('input[type="radio"][data-variant-id]');
  for (const input of modalInputs) {
    if (input instanceof HTMLInputElement && input.dataset.variantId === selectedVariantId && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      break;
    }
  }
};
if (!customElements.get("quick-add-component")) {
  customElements.define("quick-add-component", QuickAddComponent);
}
class QuickAddDialog extends DialogComponent {
  constructor() {
    super(...arguments);
    this.selectionGeneration = 0;
    this.dialogGeneration = 0;
    this.selectionDetached = false;
    __privateAdd(this, _abortController2, new AbortController());
    __publicField(this, "handleCartUpdate", (event) => {
      var _a;
      const generation = this.dialogGeneration;
      (_a = event.promise) == null ? void 0 : _a.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.dialogGeneration || (detail == null ? void 0 : detail.didError)) return;
        this.closeDialog();
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[quick-add] Event promise rejected:", error);
      });
    });
    __privateAdd(this, _handleProductSelect, (event) => {
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      const generation = ++this.selectionGeneration;
      const dialogGeneration = this.dialogGeneration;
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration || dialogGeneration !== this.dialogGeneration) return;
        if (!(detail == null ? void 0 : detail.html)) return;
        const { html } = detail;
        const anchorElement = (
          /** @type {HTMLAnchorElement} */
          html.querySelector(".view-product-title a")
        );
        const viewMoreDetailsLink = (
          /** @type {HTMLAnchorElement} */
          this.querySelector(".view-product-title a")
        );
        const mobileProductTitle = (
          /** @type {HTMLAnchorElement} */
          this.querySelector(".product-header a")
        );
        if (!anchorElement) return;
        if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
        if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[quick-add] Event promise rejected:", error);
      });
    });
    __privateAdd(this, _handleDialogClose, () => {
      const iosVersion = getIOSVersion();
      if (!iosVersion || iosVersion.major >= 17 || iosVersion.major === 16 && iosVersion.minor >= 4) return;
      requestAnimationFrame(() => {
        const grid = document.querySelector("#ResultsList [product-grid-view]");
        if (grid) {
          const currentWidth = grid.getBoundingClientRect().width;
          grid.style.width = "".concat(currentWidth - 1, "px");
          requestAnimationFrame(() => {
            grid.style.width = "";
          });
        }
      });
    });
  }
  showDialog() {
    ++this.dialogGeneration;
    return super.showDialog();
  }
  closeDialog() {
    ++this.dialogGeneration;
    ++this.selectionGeneration;
    return super.closeDialog();
  }
  connectedCallback() {
    super.connectedCallback();
    this.selectionDetached = false;
    if (__privateGet(this, _abortController2).signal.aborted) _abortController2.set(this, new AbortController());
    this.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate, {
      signal: __privateGet(this, _abortController2).signal
    });
    this.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.addEventListener(DialogCloseEvent.eventName, __privateGet(this, _handleDialogClose));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    ++this.dialogGeneration;
    this.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    __privateGet(this, _abortController2).abort();
    this.removeEventListener(DialogCloseEvent.eventName, __privateGet(this, _handleDialogClose));
  }
}
_abortController2 = /* @__PURE__ */ new WeakMap();
_handleProductSelect = /* @__PURE__ */ new WeakMap();
_handleDialogClose = /* @__PURE__ */ new WeakMap();
if (!customElements.get("quick-add-dialog")) {
  customElements.define("quick-add-dialog", QuickAddDialog);
}
export {
  QuickAddComponent
};
